"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _getAirportInfo = _interopRequireDefault(require("../getAirportInfo"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class LocationDropDown extends _react.default.Component {
  constructor(props) {
    super(props);
    this.changeLocation = this.changeLocation.bind(this);
  }
  changeLocation(e) {
    const {
      value
    } = e.target;
    const {
      onSelect
    } = this.props;
    if (onSelect) onSelect(value);
  }
  render() {
    const {
      activeLocation,
      locations,
      pageName,
      productType,
      id
    } = this.props;
    let selectedLocation = activeLocation;
    if (pageName) {
      const location = (0, _getAirportInfo.default)(pageName);
      if (location && location.code) selectedLocation = location.code;
    }
    const options = Object.keys(locations).map(location => {
      if (location.indexOf('OptGroup') !== -1) {
        const optOptions = Object.keys(locations[location]).map(optLocation => {
          return /*#__PURE__*/_react.default.createElement("option", {
            key: optLocation,
            value: optLocation
          }, locations[location][optLocation]);
        });
        return /*#__PURE__*/_react.default.createElement("optgroup", {
          key: location,
          label: location.replace('OptGroup', '')
        }, optOptions);
      } else if (typeof productType === 'undefined' || productType !== 'hcp' || location !== 'BHD') {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: location,
          value: location
        }, locations[location]);
      }
    });
    return /*#__PURE__*/_react.default.createElement("select", {
      className: "form-control",
      id: id,
      name: "Location",
      value: selectedLocation,
      onChange: this.changeLocation,
      "data-track-name": "location"
    }, options);
  }
}
LocationDropDown.propTypes = {
  activeLocation: _propTypes.string,
  pageName: _propTypes.string,
  locations: _propTypes.object.isRequired,
  onSelect: _propTypes.func,
  productType: _propTypes.string,
  id: _propTypes.string
};
LocationDropDown.defaultProps = {
  activeLocation: 'LGW',
  locations: {}
};
var _default = exports.default = LocationDropDown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/location-dropdown.js
// module id = 396
// module chunks = 119